import { PAYMENT_PROCESSOR } from 'components/UserPaymentForm/utils';

import useGetCurrentUserPaymentProcessor from './useGetCurrentUserPaymentProcessor';
import useProcessSquarePayment from './useProcessSquarePayment';
import useProcessStripePayment from './useProcessStripePayment';

const useProcessPayment = ({ renewInfo, setPaymentStatus, onPaymentComplete }) => {
	const getCurrentUserPaymentProcessor = useGetCurrentUserPaymentProcessor();

	const processPaymentSquare = useProcessSquarePayment({
		renewInfo,
		setPaymentStatus,
		onComplete: onPaymentComplete
	});

	const processPaymentStripe = useProcessStripePayment({
		setPaymentStatus,
		onComplete: onPaymentComplete
	});

	const paymentProcessor = getCurrentUserPaymentProcessor();

	return paymentProcessor === PAYMENT_PROCESSOR.stripe ? processPaymentStripe : processPaymentSquare;
};

export default useProcessPayment;
